import React from 'react';
import { connect } from 'react-redux';

import CircularProgress from 'material-ui/CircularProgress';
import RemoveCircle from 'material-ui/svg-icons/content/remove-circle-outline';

import LetterList from './List';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from 'components/Libs/Pagination';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import IconButton from 'material-ui/IconButton';
import Checkbox from 'material-ui/Checkbox';
import RabbitModal from './RabbitModal';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

import BrokerMailsModal from './BrokerMailsModal';

import * as api from 'services/letters';
import * as actionTypes from 'constants/ActionTypes';

import { execute, UserPerms } from 'store/configureStore';
import { call, put } from 'redux-saga/effects';

import defaults from 'lodash/defaults';

import globalStyles from 'styles/index';
import { DatePicker, SelectField } from 'material-ui';
import { fromUTC, toUTC } from 'helpers/dates';

import { addNotification } from 'actions/notifications/notifications';

import { bindActionCreators } from 'redux';
import _ from 'lodash';

const styles = {
    ...globalStyles,
    radioGroup: {
        margin: '20px 0',
    },
    radioButton: {
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    typeWidth: {
        width: '16%',
    },
    statusWidth: {
        width: '25%',
    },
    checkboxGroup: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
    },
    checkboxGroupTitle: {
        margin: 0,
        marginRight: '1em',
        fontWeight: 'normal',
    },
};
class LettersPage extends React.Component {
    constructor(props) {
        super(props);

        let pagination = {};
        try {
            const json = localStorage.getItem(`pagination${this.props.userId}`);
            pagination = JSON.parse(json);
        } catch (err) {}

        pagination = defaults(pagination, {
            page: 1,
            search: '',
            typeMail: '',
            statusMail: '',
            archive: false,
            fix: false,
            eh: [],
            limit: 25,
            brokerMails: [],
            listeners: [],
            showUniqueBrokerMails: false,
            isNosa: undefined,
            nosaFilter: {
                isNosa: undefined,
                isNotNosa: undefined,
            },
        });

        this.state = {
            showSpinner: true,
            rowsPerPage: [10, 25, 50],
            openBrokerFilterDialog: false,
            pagination,
            failedEmailsAmount: '',
            newEmailsAmount: '',
            toDevAmount: '',
            openRabbitDialog: false,
            openRabbitMenu: false,
            rabbitObj: {
                id: '',
                subject: '',
                text: '',
                type: '',
            },
        };

        this.updateRows = this.updateRows.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.changeTypeMails = this.changeTypeMails.bind(this);
        this.changeStatusMails = this.changeStatusMails.bind(this);
        this.handleChangeEh = this.handleChangeEh.bind(this);
        this.filterWithAttachments = this.filterWithAttachments.bind(this);
        this.changeToArchiveLetters = this.changeToArchiveLetters.bind(this);
        this.handleChangePagination = this.handleChangePagination.bind(this);

        this.handleStartDateFilter = this.handleStartDateFilter.bind(this);
        this.handleEndDateFilter = this.handleEndDateFilter.bind(this);

        this.handleRemoveDate = this.handleRemoveDate.bind(this);

        this.handleResendEmailsChange = this.handleResendEmailsChange.bind(this);
        this.handleResendEmails = this.handleResendEmails.bind(this);
        this.handleChangeSendToDev = this.handleChangeSendToDev.bind(this);
        this.handleSendToDev = this.handleSendToDev.bind(this);
        this.handleToggleBrokerFilterDialog = this.handleToggleBrokerFilterDialog.bind(this);
        this.handleFilterBroker = this.handleFilterBroker.bind(this);
        this.handleOpenRabbitDialog = this.handleOpenRabbitDialog.bind(this); 
        this.handleCloseRabbitDialog = this.handleCloseRabbitDialog.bind(this); 
        this.sendToRabbit = this.sendToRabbit.bind(this);
    }

    handleChangeEh(e, value) {
        const eh = e.target.dataset.eh;

        const pagination = {
            ...this.state.pagination,
            page: 1,
            eh: [...this.state.pagination.eh],
        };
        if (value) {
            pagination.eh.push(eh);
        } else {
            pagination.eh = pagination.eh.filter(i => i !== eh);
        }

        if (!pagination.eh.includes('broker')) {
            pagination.brokerMails = [];
            pagination.listeners = [];
        } 

        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    filterWithAttachments() {
        this.setState(state => ({
            pagination: {
                ...state.pagination,
                page: 1,
                withAttachments: !state.pagination.withAttachments,
            },
        }), () => {
            this.updateRows(this.state);
        });
    }

    changeToArchiveLetters(e, value) {
        const d = new Date();
        let dateStart;
        if (value && !this.state.dateStart) {
            dateStart = toUTC(d.setMonth(d.getMonth() - 3));
        }

        const pagination = {
            ...this.state.pagination,
            dateStart,
            page: 1,
            archive: value,
        };

        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    changeTypeMails(e, value) {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            typeMail: value,
        };

        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    changeStatusMails(e, value) {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            statusMail: value,
        };

        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleSearch() {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            search: this.refs.search.input.value,
        };

        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleChangePagination({ page, numberOfRows }) {
        this.setState({
            pagination: {
                ...this.state.pagination,
                page,
                limit: numberOfRows,
            },
        }, () => {
            this.updateRows(this.state);
        });
    }

    async updateRows(state) {
        const pagination = {
            ...state.pagination,
        };

        await execute(this.loadLetters, pagination);

        this.setState({
            pagination,
        });

        this.saveToLocalStorage(pagination);
    }

    * loadLetters(pagination) {
        let response = yield call(api.getLetters, pagination);
        
        if (response.status === 400) {
            pagination.page = 1;
            response = yield call(api.getLetters, pagination);
        }

        yield put({
            type: actionTypes.GET_LETTERS,
            data: response,
        });
    }

    saveToLocalStorage(pagination) {
        localStorage.setItem(
            `pagination${this.props.userId}`,
            JSON.stringify(pagination),
        );
    }

    componentDidMount() {
        this.updateRows(this.state).then(() => this.setState({
            showSpinner: false,
        }));
    }

    handleStartDateFilter(e, date) {
        const pagination = {
            ...this.state.pagination,
            page: 1,
            dateStart: toUTC(date),
        };
        
        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleEndDateFilter(e, date) {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59));
        const pagination = {
            ...this.state.pagination,
            page: 1,
            dateEnd: newDate.toISOString(),
        };
        
        
        this.setState({
            pagination,
        }, () => {
            this.updateRows(this.state);
        });
    }

    handleRemoveDate(type) {
        const state = _.cloneDeep(this.state);
        const ls = JSON.parse(localStorage[`pagination${this.props.userId}`]);
        
        if (type === 'start') {
            delete state.pagination.dateStart;
            delete ls.dateStart;
        } else if (type === 'end') {
            delete state.pagination.dateEnd;
            delete ls.dateEnd;
        }
        
        this.setState({
            ...state,
        }, () => {
            this.updateRows(this.state);
        });
        localStorage.setItem(`pagination${this.props.userId}`, JSON.stringify(ls));
    }

    handleResendEmailsChange(ev, emailStatus) {
        this.setState({
            [`${emailStatus}EmailsAmount`]: ev.target.value,
        });
    }

    handleChangeSendToDev(ev) {
        this.setState({
            toDevAmount: ev.target.value,
        });
    }

    async handleSendToDev(mailStatus) {
        const { toDevAmount } = this.state;

        if (!toDevAmount) {
            this.props.addNotification({
                title: 'Error',
                level: 'error',
                _id: new Date().getMilliseconds(),
                message: 'Select amount of emails',
                autoDismiss: 25,
            });

            return;    
        }

        const response = await api.saveEmailsToDev(mailStatus, parseInt(toDevAmount));

        if (await response.status === 200) {
            this.props.addNotification({
                title: 'Success',
                level: 'success',
                _id: new Date().getMilliseconds(),
                message: `Amount of ${mailStatus} emails saved dev`,
                autoDismiss: 25,
            });
        }

        if (response.status === 400) {
            this.props.addNotification({
                title: 'Error',
                level: 'error',
                _id: new Date().getMilliseconds(),
                message: response.errors[0].message,
                autoDismiss: 25,
            });
        }

        await execute(this.loadLetters, this.state.pagination);
    }

    async handleResendEmails(emailStatus) {
        const intEmailsAmount = parseInt(this.state[`${emailStatus}EmailsAmount`]);
        const { total } = this.props.letters;
        const pagination = {
            ...this.state.pagination,
        };

        if (intEmailsAmount && intEmailsAmount > 0 && intEmailsAmount <= total) {
            const response = await api.sendEmailsToNew(intEmailsAmount, emailStatus, total);
            if (await response.status === 200) {
                this.props.addNotification({
                    title: 'Success',
                    level: 'success',
                    _id: new Date().getMilliseconds(),
                    message: `Amount of emails changed from ${emailStatus} to new: ${response.data.amount}`,
                    autoDismiss: 25,
                });
            }
    
            if (response.status === 400) {
                this.props.addNotification({
                    title: 'Error',
                    level: 'error',
                    _id: new Date().getMilliseconds(),
                    message: response.errors[0].message,
                    autoDismiss: 25,
                });
            }
            this.setState({
                [`${emailStatus}EmailsAmount`]: '',
            });
            await execute(this.loadLetters, pagination);
        } else {
            this.props.addNotification({
                title: 'Error',
                level: 'error',
                _id: new Date().getMilliseconds(),
                message: `Amount of error emails out of range. Expected range: 1 to ${total}`,
                autoDismiss: 25,
            });
            this.setState({
                [`${emailStatus}EmailsAmount`]: '',
            });
        }
    }

    handleToggleBrokerFilterDialog() {
        this.setState(state => ({
            openBrokerFilterDialog: !state.openBrokerFilterDialog,
        }));
    }

    async handleFilterBroker(brokerMails, listeners) {
        const pagination = {
            ...this.state.pagination,
            brokerMails,
            listeners,
        };
        
        await this.updateRows({ ...this.state, pagination });
        this.handleToggleBrokerFilterDialog();
    }

    handleOpenRabbitDialog() {
        this.setState({ openRabbitDialog: true });
    }
    
    handleCloseRabbitDialog() {
        this.setState({ openRabbitDialog: false });
    }

    handleOpenRabbitMenu = () => {
        this.setState({ openRabbitDialog: true });
    };
    
    handleCloseRabbitMenu = () => {
        this.setState({ openRabbitDialog: false });
    };

    async sendToRabbit(idsArr) {
        const response = await api.sendToRabbit(idsArr);
        
        if (await response.status === 200) {
            this.props.addNotification({
                title: 'Success',
                level: 'success',
                _id: new Date().getMilliseconds(),
                message: `Amount of resent emails: ${response.data.amount}`,
                autoDismiss: 25,
            });
            await execute(this.loadLetters, this.state.pagination);
        }

        if (response.status === 400) {
            this.props.addNotification({
                title: 'Error',
                level: 'error',
                _id: new Date().getMilliseconds(),
                message: response.errors[0].message,
                autoDismiss: 25,
            });
        }
    }

    handleToggleShowUniqueBrokerMails = () => {
        this.setState({
            pagination: {
                ...this.state.pagination,
                showUniqueBrokerMails: !this.state.pagination.showUniqueBrokerMails,
            },
        });
    }

    /**
     * 
     * @param {'isNosa' | 'isNotNosa'} field 
     * @param {boolean} value 
     */
    handleChangeIsNosaFilter = async (field, value) => {
        const _pagination = _.cloneDeep(this.state.pagination);

        _.set(_pagination, `nosaFilter.${field}`, value);

        if (_pagination.nosaFilter.isNosa && !_pagination.nosaFilter.isNotNosa) {
            _.set(_pagination, 'isNosa', true);
        } else if (!_pagination.nosaFilter.isNosa && _pagination.nosaFilter.isNotNosa) {
            _.set(_pagination, 'isNosa', false);
        } else {
            _.set(_pagination, 'isNosa', undefined);
        }

        this.setState({
            pagination: _pagination,
        });

        await execute(this.loadLetters, _pagination);
    }

    render() {
        const {
            pagination: {
                search, page, limit, statusMail, eh, archive, typeMail, withAttachments, dateStart, dateEnd, showUniqueBrokerMails, 
                nosaFilter,
            }, rowsPerPage, openBrokerFilterDialog,
        } = this.state;
        const {
            total, brokerMails, selectedBrokerMails, listeners, selectedListeners, 
        } = this.props.letters;
        const { rabbitObj, openRabbitDialog } = this.state;

        const minDate = new Date();
        const maxDate = new Date();
        const currentMailStatus = this.state.pagination.statusMail || '';
        
        minDate.setFullYear(minDate.getFullYear() - 1);
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        return (
            <div id='letters-page' className='page'>
                <CircularProgress
                    className={this.state.showSpinner ? '' : 'hidden'}
                    style={styles.circularProgress}
                />
                {
                    openBrokerFilterDialog &&
                        <BrokerMailsModal 
                            brokerMails={brokerMails}
                            selectedListeners={selectedListeners}
                            listeners={listeners}
                            handleClose={this.handleToggleBrokerFilterDialog}
                            handleFilterBroker={this.handleFilterBroker}
                            selectedBrokerMails={selectedBrokerMails}
                            showUniqueBrokerMails={showUniqueBrokerMails}
                            handleToggleShowUniqueBrokerMails={this.handleToggleShowUniqueBrokerMails}
                        />
                }

                <RabbitModal 
                    rabbitObj={rabbitObj}
                    open={openRabbitDialog}
                    handleClose={this.handleCloseRabbitDialog}
                    handleChange={this.changeField}
                    sendToRabbit={this.sendToRabbit}
                    letters={this.props.letters}
                />

                <div className={this.state.showSpinner ? 'hidden' : ''}>
                    <div className='container'>
                        <h2>
                           Letters
                        </h2>

                        <div>
                            <div className='letters-header'>
                                <div className='letters-header-item'>
                                    <TextField
                                        defaultValue={search}
                                        hintText='Search'
                                        ref='search'
                                        onKeyPress={(event) => {
                                            if (event.charCode === 13) {
                                                event.preventDefault();
                                                this.handleSearch();
                                            }
                                        }}
                                    />
                                    <RaisedButton
                                        label='Search'
                                        style={styles.RaisedButton}
                                        primary
                                        onClick={this.handleSearch}
                                    />
                                </div>
                                <div className='letters-header-item'>
                                    <Pagination
                                        total={total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        numberOfRows={limit}
                                        updateRows={this.handleChangePagination}
                                    />
                                </div>
                            </div>
                            <div className='letters-info'>
                                <div className='letters-info-item'>
                                    TOTAL:  { total }
                                </div>
                                <div className='letters-info-item'>
                                    PAGES:  { Math.ceil(total / limit) }
                                </div>
                            </div>
                            <div className='filters-mails'>
                                <div className='filter filter-type-mail'>
                                    Filter by type:
                                    <RadioButtonGroup
                                        onChange={this.changeTypeMails}
                                        style={styles.radioGroup}
                                        name='type-mail'
                                        defaultSelected={typeMail}
                                    >
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value=''
                                            label='All'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value='vessel'
                                            label='Vessel'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value='sales'
                                            label='Sales'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value='cargo'
                                            label='Cargo'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value='tc'
                                            label='TC'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.typeWidth }}
                                            value='spam'
                                            label='Spam'
                                        />
                                    </RadioButtonGroup>
                                    <div className='filter filter-date-picker'>
                                        <div className='filter-checkboxes'>
                                            <Checkbox
                                                label='Archive letters'
                                                checked={archive}
                                                onCheck={this.changeToArchiveLetters}
                                            />
                                            <Checkbox
                                                label='Only with attachments'
                                                checked={withAttachments}
                                                onCheck={this.filterWithAttachments}
                                            />
                                        </div>
                                        <div className='filter-date-inputs'>
                                            <DatePicker 
                                                floatingLabelText='Filter start date:'
                                                autoOk
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                textFieldStyle={{ width: '120px' }}
                                                shouldDisableDate={dateSelected => dateSelected.getTime() > new Date(dateEnd).getTime()}
                                                onChange={this.handleStartDateFilter}
                                                // value={dateStart ? new Date(dateStart) : undefined}
                                                value={dateStart ? fromUTC(dateStart) : undefined}
                                            />
                                            <IconButton
                                                style={{ margin: '25px 7px 0 -7px' }}
                                                disabled={!dateStart}
                                                onClick={() => this.handleRemoveDate('start')}
                                            >
                                                <RemoveCircle 
                                                    color={dateStart ? 'red' : 'black'}
                                                />
                                            </IconButton>
                                            <DatePicker 
                                                floatingLabelText='Filter end date:'
                                                autoOk
                                                minDate={minDate}
                                                maxDate={maxDate}
                                                textFieldStyle={{ width: '120px' }}
                                                
                                                shouldDisableDate={dateSelected => dateSelected.getTime() < new Date(dateStart).getTime()}

                                                onChange={this.handleEndDateFilter}
                                                // value={dateEnd ? new Date(dateEnd) : undefined}
                                                value={dateEnd ? fromUTC(dateEnd) : undefined}
                                            />
                                            <IconButton
                                                style={{ margin: '25px 0 0 -7px' }}
                                                disabled={!dateEnd}
                                                onClick={() => this.handleRemoveDate('end')}
                                            >
                                                <RemoveCircle 
                                                    color={dateEnd ? 'red' : 'black'}
                                                />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>

                                <div className='filter filter-status-mail '>
                                    Filter by status:
                                    <RadioButtonGroup
                                        onChange={this.changeStatusMails}
                                        style={styles.radioGroup}
                                        name='status-mail'
                                        defaultSelected={statusMail}
                                    >
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.statusWidth }}
                                            value=''
                                            label='All'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.statusWidth }}
                                            value='sent'
                                            label='Sent'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.statusWidth }}
                                            value='failed'
                                            label='Failed'
                                        />
                                        <RadioButton
                                            style={{ ...styles.radioButton, ...styles.statusWidth }}
                                            value='new'
                                            label='New'
                                        />
                                    </RadioButtonGroup>
                                    <div style={styles.checkboxGroup}>
                                        <h3 style={styles.checkboxGroupTitle}>From: </h3>
                                        <Checkbox
                                            label='Fix'
                                            data-eh="fix"
                                            checked={eh.includes('fix')}
                                            iconStyle={{
                                                marginRight: '8px',
                                            }}
                                            onCheck={this.handleChangeEh}
                                        />
                                        <Checkbox
                                            label='Varamar'
                                            data-eh="varamar"
                                            checked={eh.includes('varamar')}
                                            iconStyle={{
                                                marginRight: '8px',
                                            }}
                                            onCheck={this.handleChangeEh}
                                        />
                                        <Checkbox
                                            label='Fixture'
                                            data-eh="fixture"
                                            checked={eh.includes('fixture')}
                                            iconStyle={{
                                                marginRight: '8px',
                                            }}
                                            onCheck={this.handleChangeEh}
                                        />
                                        <Checkbox
                                            label='Api'
                                            data-eh="api"
                                            checked={eh.includes('api')}
                                            iconStyle={{
                                                marginRight: '8px',
                                            }}
                                            onCheck={this.handleChangeEh}
                                        />
                                        <Checkbox
                                            label='Broker'
                                            data-eh="broker"
                                            checked={eh.includes('broker')}
                                            iconStyle={{
                                                marginRight: '8px',
                                            }}
                                            onCheck={this.handleChangeEh}
                                        />
                                        {
                                            UserPerms.isAdmin &&
                                                <IconMenu
                                                    disableAutoFocus
                                                    iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                                                    anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                                                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                                                >
                                                    <MenuItem
                                                        style={{ backgroundColor: 'transparent' }}
                                                    >
                                                        <TextField
                                                            hintText='Amount'
                                                            style={{ width: '95px', marginRight: '20px' }}
                                                            onClick={e => e.stopPropagation()}
                                                            onChange={ev => this.handleResendEmailsChange(ev, 'failed')}
                                                            value={this.state.failedEmailsAmount}
                                                            type='number'
                                                        />
                                                        <RaisedButton 
                                                            label='Failed to New'
                                                            secondary
                                                            buttonStyle={{ width: '130px' }}
                                                            onClick={() => this.handleResendEmails('failed')}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        style={{ backgroundColor: 'transparent' }}
                                                    >
                                                        <TextField
                                                            hintText='Amount'
                                                            style={{ width: '95px', marginRight: '20px' }}
                                                            onClick={e => e.stopPropagation()}
                                                            onChange={ev => this.handleResendEmailsChange(ev, 'new')}
                                                            value={this.state.newEmailsAmount}
                                                            type='number'
                                                        />
                                                        <RaisedButton 
                                                            label='New to New'
                                                            secondary
                                                            buttonStyle={{ width: '130px' }}
                                                            onClick={() => this.handleResendEmails('new')}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        style={{ backgroundColor: 'transparent' }}
                                                    >
                                                        <TextField
                                                            hintText='Amount'
                                                            style={{ width: '95px', marginRight: '20px' }}
                                                            onClick={e => e.stopPropagation()}
                                                            onChange={ev => this.handleChangeSendToDev(ev)}
                                                            value={this.state.toDevAmount}
                                                            type='number'
                                                        />
                                                        <RaisedButton 
                                                            label={`${currentMailStatus} to Dev`}
                                                            secondary
                                                            buttonStyle={{ width: '130px' }}
                                                            onClick={() => this.handleSendToDev(currentMailStatus)}
                                                        />
                                                    </MenuItem>
                                                    <MenuItem
                                                        primaryText="BROKER EMAIL FILTER"
                                                        onClick={() => { this.handleToggleBrokerFilterDialog(); }}
                                                        style={{
                                                            margin: '6px 10px', 
                                                            textAlign: 'center', 
                                                            color: 'white', 
                                                            backgroundColor: '#FF4081', 
                                                            width: '250px', 
                                                        }}
                                                    />
                                                    <MenuItem
                                                        primaryText='Open Requeue Modal'
                                                        onClick={() => { this.handleOpenRabbitDialog(); }}
                                                        style={{
                                                            margin: '6px 10px', 
                                                            textAlign: 'center', 
                                                            color: 'white', 
                                                            backgroundColor: '#FF4081', 
                                                            width: '250px', 
                                                        }}
                                                    />
                                                    <MenuItem
                                                        style={{ 
                                                            backgroundColor: 'transparent',
                                                            width: '250px', 
                                                            margin: '6px 8px', 
                                                        }}
                                                        innerDivStyle={{
                                                            padding: 0,
                                                        }}
                                                    >
                                                        <Checkbox
                                                            label='noSa'
                                                            checked={nosaFilter.isNosa}
                                                            iconStyle={{
                                                                marginRight: '8px',
                                                            }}
                                                            style={{
                                                                display: 'inline-block',
                                                                width: '35%',
                                                                verticalAlign: 'middle',
                                                            }}
                                                            onCheck={() => this.handleChangeIsNosaFilter('isNosa', !nosaFilter.isNosa)}
                                                        />
                                                        <Checkbox
                                                            label='noSa'
                                                            checked={nosaFilter.isNotNosa}
                                                            labelStyle={{
                                                                textDecoration: 'line-through',
                                                            }}
                                                            iconStyle={{
                                                                marginRight: '8px',
                                                            }}
                                                            style={{
                                                                display: 'inline-block',
                                                                width: 'unset',
                                                                verticalAlign: 'middle',
                                                            }}
                                                            onCheck={() => this.handleChangeIsNosaFilter('isNotNosa', !nosaFilter.isNotNosa)}
                                                        />
                                                    </MenuItem>
                                                </IconMenu>
                                        }
                                    </div>
                                </div>
                            </div>
                            <LetterList 
                                letters={{ 
                                    ...this.props.letters, 
                                    data: this.props.letters && this.props.letters.data ? this.props.letters.data : [],
                                }} 
                                userId={this.props.userId}
                            />
                            <div className='letters-header'>
                                <div className='letters-header-item'>
                                    <Pagination
                                        total={total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        numberOfRows={limit}
                                        updateRows={this.handleChangePagination}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ user, letters }) => ({
        letters,
        userId: user.user._id,
        isLogged: user.isLogged,
    }),
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(LettersPage);



// WEBPACK FOOTER //
// ./app/components/Letters/List/Page.jsx